
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Convectionpatientwarmerblanket() {



  const cardData =
  {
    keyword: 'Convection Patient Warmer Blanket Manufacturers',
    heading: 'Pharmacle Health Care Private Limited: Convection Patient Warmer Blanket Manufacturers',
    headingDescription: 'Pharmacle Health Care Private Limited is a leading manufacturer of Convection Patient Warmer Blankets, providing advanced thermal care solutions for hospitals and surgical centers across India. Our convection warmer blankets utilize forced-air technology to deliver consistent, controlled heat, effectively preventing perioperative hypothermia and enhancing patient safety. Designed with cutting-edge features, our blankets ensure uniform heat distribution, are easy to operate, and integrate seamlessly into various clinical settings. Trusted by healthcare professionals nationwide, Pharmacle Health Care is convection patient warmer blankets are the optimal choice for reliable and efficient patient temperature management.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',

"topPlaces": [
  {
    "title": "Therma Patient Warmer Device – Made in India",
    "description": "Pharmacle Health Care Private Limited proudly supplies the Therma Patient Warmer Device, an indigenous solution developed in India for effective convective warming therapy. Each device comes with a complimentary blanket and has been successfully installed in leading hospitals nationwide. It ensures patient comfort and safety during surgical procedures."
  },
  {
    "title": "Calima™ Convective Forced Air Patient Warming System",
    "description": "Pharmacle Health Care Private Limited offers the Calima™ Convective Forced Air Patient Warming System, designed for efficient temperature management. Featuring a comprehensive range of overbody and underbody blankets, the system ensures uniform heat distribution. Its lightweight and compact design makes it ideal for diverse clinical applications."
  },
  {
    "title": "GenTherm Convective WarmAir Patient Blanket System",
    "description": "Pharmacle Health Care Private Limited provides the GenTherm WarmAir convective system, engineered for consistent patient warming through advanced heat transfer technology. The uniformly perforated blankets ensure even heat distribution and compatibility with multiple warming units, helping maintain patient normothermia during surgeries."
  },
  {
    "title": "Cocoon Convective Warming Machine CWS 4000",
    "description": "As an authorized supplier, Pharmacle Health Care Private Limited distributes the Cocoon CWS 4000, a microprocessor-controlled convective warming machine. FDA, CE, TGA, and Health Canada approved, it features advanced safety monitoring and filter status indicators. Designed for ease of use, it delivers precise and effective patient warming."
  },
  {
    "title": "3M™ Bair Hugger™ Warming Blanket 55000",
    "description": "Pharmacle Health Care Private Limited also provides the 3M™ Bair Hugger™ Warming Blanket 55000, a trusted convective warming solution. Made from soft, radiolucent materials with uniform perforations, it minimizes fluid pooling and enhances patient comfort. The system is suitable for a wide variety of surgical procedures."
  }
],

"services": [
    {
        "name": "Convection Patient Warmer Blanket Manufacturers",
        "description": "Pharmacle Health Care is a leading manufacturer of convection patient warmer blankets, designed to regulate and maintain patient body temperature during medical procedures. These blankets use advanced convective heating technology to ensure consistent warmth, preventing hypothermia during surgeries, recovery, and critical care. Our convection patient warmer blankets are trusted by hospitals and clinics for their effectiveness in promoting patient comfort and safety."
    },
    {
        "name": "Convective Warming Blanket Suppliers",
        "description": "We are trusted suppliers of convective warming blankets, providing healthcare facilities with essential tools to maintain safe body temperatures for patients undergoing medical treatments. These blankets utilize forced air technology to deliver warmth efficiently, preventing thermal instability and ensuring patient comfort. Our convective warming blankets are ideal for operating rooms, recovery areas, and critical care settings."
    },
    {
        "name": "Forced Air Convection Blanket India",
        "description": "Pharmacle Health Care offers forced air convection blankets in India, designed to provide controlled warmth during surgeries and post-operative care. These blankets use a unique system to circulate warm air around the patient’s body, ensuring temperature regulation and reducing the risks of hypothermia. They are an essential part of medical procedures that require precise body temperature management, trusted by healthcare providers across India."
    },
    {
        "name": "Surgical Convective Heat Blanket",
        "description": "Our surgical convective heat blankets are specifically designed to maintain a safe and consistent body temperature during surgeries. Using convective air circulation technology, these blankets prevent heat loss and reduce the risk of hypothermia in patients, especially during prolonged surgical procedures. With precise temperature control and easy-to-use functionality, they are a crucial part of modern operating room equipment."
    },
    {
        "name": "Operating Room Convection Blanket",
        "description": "We provide operating room convection blankets that are designed to provide precise thermal regulation during surgeries. These blankets use forced air circulation to maintain patient warmth, reducing the risk of complications caused by hypothermia. The blankets are lightweight, efficient, and easy to integrate into operating room settings, ensuring optimal comfort and safety for patients undergoing surgical procedures."
    },
    {
        "name": "Thermal Patient Warming Blankets",
        "description": "Our thermal patient warming blankets are designed to regulate body temperature and prevent hypothermia during medical treatments. These blankets use advanced thermal technology to maintain warmth, providing consistent heat during surgeries, post-operative recovery, and critical care. Trusted by medical professionals, these blankets enhance patient comfort and safety by preventing temperature-related complications."
    },
    {
        "name": "Hospital Air Heat Blankets",
        "description": "Pharmacle Health Care provides hospital air heat blankets that deliver controlled warmth during medical procedures. These blankets are designed to circulate warm air around the patient’s body, ensuring consistent and reliable thermal regulation. Ideal for use in hospitals, our air heat blankets are effective in preventing hypothermia, promoting comfort, and improving recovery times for patients in operating rooms and critical care units."
    },
    {
        "name": "Patient Body Heating Blankets",
        "description": "Our patient body heating blankets are designed to provide effective and reliable temperature regulation during medical treatments. These blankets use advanced heating technology to prevent body temperature fluctuations, ensuring patient comfort and safety. Whether used in surgeries, post-operative care, or critical care settings, our patient body heating blankets are vital for maintaining optimal thermal conditions and reducing the risks of hypothermia."
    }
],
"tableData": [
    ["- Convection Patient Warmer Blanket Manufacturers", "- Convective Warming Blanket Suppliers"],
    ["- Forced Air Convection Blanket India", "- Surgical Convective Heat Blanket"],
    ["- Operating Room Convection Blanket", "- Thermal Patient Warming Blankets"],
    ["- Hospital Air Heat Blankets", "- Patient Body Heating Blankets"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "As leading Convection Patient Warmer Blanket Manufacturers, we provide state-of-the-art convection warming technology. Our blankets offer precise, controlled warmth during medical procedures, ensuring patient comfort and preventing hypothermia."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We offer a range of Convection Patient Warmer Blankets that deliver even, consistent heat. Designed for use in hospitals and clinics, our blankets ensure patients are kept warm and comfortable throughout their treatments."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our Convection Patient Warmer Blankets are manufactured with the highest quality materials for durability and reliability. Rigorously tested for long-term use, these blankets provide optimal performance in demanding medical environments."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our Convection Patient Warmer Blankets provide gentle, controlled heat that minimizes the risk of temperature-related complications during surgeries and other medical procedures."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our Convection Patient Warmer Blankets are versatile and adaptable, meeting the needs of various healthcare settings. Whether in operating rooms, recovery areas, or intensive care units, our blankets are designed to ensure patient comfort and safety."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Designed for ease of use, our Convection Patient Warmer Blankets integrate smoothly into existing medical systems. They are simple to deploy and operate, ensuring continuous patient warming without disrupting ongoing medical procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We provide expert consultation services to help healthcare providers select the right Convection Patient Warmer Blankets for their needs. Our team offers ongoing support and maintenance to ensure the blankets continue to perform optimally."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the heart of our mission. Our Convection Patient Warmer Blankets are designed to prevent temperature-related issues, ensuring that every patient receives the best care during their treatment."
    }
]


















  }

  const faqData = [
    {
      question: "Who are the leading Convection Patient Warmer Blanket manufacturers?",
      answer: "Pharmacle Health Care Private Limited is one of the leading manufacturers of Convection Patient Warmer Blankets. Their products are designed to deliver consistent warm air flow through specialized blankets, helping maintain patient body temperature during surgical and medical procedures."
    },
    {
      question: "What is a Convection Patient Warmer Blanket?",
      answer: "A Convection Patient Warmer Blanket is a medical device that uses warm air circulation to maintain a patient’s body temperature. It connects to a Forced Air Warming System, which blows heated air through the blanket to prevent hypothermia during surgery or recovery."
    },
    {
      question: "Why choose Pharmacle Health Care’s Convection Warmer Blankets?",
      answer: "Pharmacle Health Care’s convection warmer blankets are known for their uniform heat distribution, safety features, and compatibility with a wide range of warming units, making them a trusted solution in hospitals and clinics."
    },
    {
      question: "Are Pharmacle Health Care’s Convection Warmer Blankets reusable or disposable?",
      answer: "Pharmacle Health Care offers both reusable and single-use convection warmer blankets to meet the hygiene and operational needs of different healthcare facilities."
    },
    {
      question: "Do Pharmacle Health Care blankets comply with medical safety standards?",
      answer: "Yes, all Convection Patient Warmer Blankets manufactured by Pharmacle Health Care meet stringent medical safety standards and are tested for performance, patient comfort, and temperature control."
    }
  ];
  
  const testimonialsData = [
    {
      text: "We use Pharmacle Health Care’s convection warmer blankets regularly in our surgical suites. They are reliable, effective, and improve overall patient care.",
      name: "Dr. Anil Mehra, Medisurge Hospital"
    },
    {
      text: "The quality and consistency of heat provided by Pharmacle’s convection blankets have helped us minimize hypothermia risks during procedures.",
      name: "Cityline Multispecialty Clinic"
    }
  ];
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Convection Patient Warmer Blanket Manufacturers",
    "description": "Top Convection Patient Warmer Blanket Manufacturers in India providing convective warming solutions, including forced air convection blankets, surgical heat blankets, and thermal patient heating systems for hospitals and operating rooms.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.8",
      "ratingCount": "1354"
    }
  };
  
 
  
  

  

  return (
    <div>
 <Helmet>
    <title>Convection Patient Warmer Blanket Manufacturers | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Find trusted Convection Patient Warmer Blanket Manufacturers in India. Supplying convective warming blankets, forced air heat blankets, and surgical thermal systems. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Convection Patient Warmer Blanket Manufacturers, Convective Warming Blanket Suppliers, Forced Air Convection Blanket India, Surgical Convective Heat Blanket, Operating Room Convection Blanket, Thermal Patient Warming Blankets, Hospital Air Heat Blankets, Patient Body Heating Blankets"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/47.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Convectionpatientwarmerblanket;